import { defineProperty as _defineProperty, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as PropTypes from 'prop-types';
import * as React from 'react';

class Spinner extends React.Component {
  // eslint-disable-line

  constructor(props) {
    super(props);
    _defineProperty(this, "queueTransitionEnd", []);
    _defineProperty(this, "srRef", void 0);
    _defineProperty(this, "transitionEnd", () => {
      if (this.queueTransitionEnd.length > 0) {
        var next = this.queueTransitionEnd.shift();
        this.setState(next);
      }
    });
    _defineProperty(this, "displaySpinner", () => {
      this.setState({
        inTransition: true,
        screenreaderVisible: true,
        spinnerInDOM: true
      });
      setTimeout(() => {
        // DOM needs to update before applying class...
        this.setState({
          spinnerVisible: true
        });
        if (this.srRef.current !== null) {
          this.srRef.current.focus();
        }
      }, 100);
      this.queueTransitionEnd.push({
        inTransition: false,
        isVisible: true
      });
    });
    _defineProperty(this, "hideSpinner", () => {
      this.setState({
        inTransition: true,
        spinnerVisible: false
      });
      this.queueTransitionEnd.push({
        inTransition: false,
        isVisible: false,
        screenreaderVisible: false,
        spinnerInDOM: false
      });
    });
    this.srRef = /*#__PURE__*/React.createRef();
    if (!this.props.isVisible) {
      this.state = {
        inTransition: false,
        isVisible: false,
        loadingTextVisible: false,
        screenreaderVisible: false,
        spinnerInDOM: false,
        spinnerVisible: false
      };
    } else {
      this.state = {
        inTransition: false,
        isVisible: true,
        loadingTextVisible: true,
        screenreaderVisible: true,
        spinnerInDOM: true,
        spinnerVisible: true
      };
    }
  }
  componentDidUpdate(prevProps) {
    if (this.state.inTransition === false) {
      if (!prevProps.isVisible && this.props.isVisible) {
        // Display the spinner
        this.displaySpinner();
      } else if (prevProps.isVisible && !this.props.isVisible) {
        // Hide the spinner
        this.hideSpinner();
      } else if (!this.props.isVisible && this.state.isVisible) {
        // The spinner finished displaying, but now it should be hidden
        this.hideSpinner();
      } else if (this.props.isVisible && !this.state.isVisible) {
        // The spinner finished hiding, but should be displayed
        this.displaySpinner();
      } else if (!this.props.isVisible && this.props.isVisible === this.state.isVisible && typeof this.props.onClose === 'function') {
        // The spinner has finished fade out
        this.props.onClose();
      }
    }
  }
  render() {
    var attributes = {
      'aria-atomic': 'true',
      className: 'spinner',
      role: 'status'
    }; // eslint-disable-line

    if (this.state.spinnerVisible) {
      attributes.className += ' spinner--visible';
    }
    if (this.props.ariaLive) {
      attributes['aria-live'] = this.props.ariaLive;
    }
    var hcid = "".concat(Spinner.name.toLocaleLowerCase(), "-").concat("10.6.2");
    return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
      "data-hcid": hcid
    }), this.state.spinnerInDOM && /*#__PURE__*/React.createElement("div", {
      className: "spinner__indicator",
      "aria-hidden": "true",
      onTransitionEnd: this.transitionEnd
    }), this.state.loadingTextVisible && this.props.loadingText && /*#__PURE__*/React.createElement("div", {
      className: "spinner__text"
    }, this.props.loadingText), this.state.screenreaderVisible && this.props.screenreaderText && /*#__PURE__*/React.createElement("div", {
      tabIndex: -1,
      className: "sr-only",
      ref: this.srRef
    }, this.props.screenreaderText));
  }
}

// @ts-ignore 
Spinner.defaultProps = {
  ariaLive: 'polite',
  isVisible: false,
  // eslint-disable-line
  screenreaderText: 'Loading. Please wait.'
};
// @ts-ignore 
Spinner.propTypes = {
  ariaLive: PropTypes.string,
  isVisible: PropTypes.bool,
  loadingText: PropTypes.string,
  onClose: PropTypes.func,
  screenreaderText: PropTypes.string
};

export { Spinner };
